import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-export-project-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  templateUrl: './export-project-dialog.component.html',
  styleUrls: ['./export-project-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExportProjectDialogComponent {
  private dialogRef = inject<MatDialogRef<ExportProjectDialogComponent>>(MatDialogRef);
  private fb = inject(FormBuilder);

  exportForm: FormGroup;
  hidePassword: boolean = true;
  isExporting: boolean = false;
  error: string | null = null;

  constructor() {
    this.exportForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(6)]],
    });
  }

  export(): void {
    if (this.exportForm.valid) {
      this.dialogRef.close(this.exportForm.value.password);
    } else {
      this.exportForm.markAllAsTouched();
    }
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
